<!--
  This work has been created or enhanced by
    Markus Luckey, 2025, KERNBLICK GmbH

  This file is covered by the EU PL 1.2 license.
  You may obtain a copy of the licence at
  https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
-->

<template>
  <div
    id="body"
    :style="cssVars"
    class="h-100 d-flex flex-column"
  >
    <div id="header">
      <HamMenu :apps="apps" />
    </div>
    <div
      id="content"
      class="flex-grow-1"
    >
      <template
        v-for="(comp, index) in hideComponents"
        :key="index"
      >
        <component
          :is="comp"
          v-show="$route.name == comp"
          :apps="apps"
        />
      </template>
      <template
        v-for="(comp, index) in reloadComponents"
        :key="index"
      >
        <component
          :is="comp"
          v-if="$route.name == comp"
        />
      </template>
    </div>
  </div>
</template>

<script>
// Apps
import AccessDenied from '@/components/AccessDenied.vue';
import Debug from '@/components/Debug.vue';

// Sub Apps
import Apps from '@/views/Apps.vue';
import Callback from '@/views/Callback.vue';
import Home from '@/views/Home.vue';
import LoggedOut from '@/views/LoggedOut.vue';
import Logout from '@/views/Logout.vue';

// Single components
import HamMenu from '@/components/HamMenu.vue';

// Support
import AppService from '@/services/AppService';
import Mgr from '@/services/SecurityService';

export default {
  name: 'App',
  components: {
    Apps, Home,
    AccessDenied,
    HamMenu: HamMenu,
    Debug,
    Callback, Logout, LoggedOut,
  },
  data() {
    return {
      mgr: new Mgr(),
      signedIn: false,
      apps: [],
      // The following components are only hidden once another of these components is opened
      hideComponents: ['Home', 'Apps'],
      // The following components are reloaded every time they are accessed
      reloadComponents: ['AccessDenied', 'Debug', 'Callback', 'Logout', 'LoggedOut'],
    };
  },
  computed: {
    cssVars() {
      return {
      }
    }
  },
  watch: {
    async signedIn(newVal) {
      await this.getApps();
    }
  },
  async mounted() {
    console.debug("App mounted, check signed in")

    if (this.mgr.isAuthorizationEnabled()) {
      this.mgr.getSignedIn().then(
        async signIn => {
          this.signedIn = signIn
        },
        err => {
          console.log(err)
        }
      )
    } else {
      this.signedIn = true;
    }

    this.getApps();
  },
  methods: {
    async getApps() {
      let result=await AppService.fetchApps();
      if(result) {
        this.apps=result.map((a) => { const b=a; b.path=`/app/${b.id}`; return b; });
        console.debug("Apps:", this.apps);
      } else {
        console.error("Could not fetch data from apps.js...");
      }
    }
  },
};
</script>

<style>
#app {
  height: 100vh;
}

#header {
  position: sticky;
  top: 0;
  background-color: var(--bs-body-bg);
  z-index: 2;
}

#content {
  overflow: auto;
}
</style>
